'use client';

import { useMedia } from 'react-use';

import { Link } from '@/components/Link/Link';
import { href, title } from '@/lib/links-fields';
import type { Footer } from '@/src/types';

import FooterLinksMobile from './FooterLinksMobile';

import styles from './FooterLinks.module.scss';

export default function FooterLinks({ footerGlobal }: { footerGlobal: Footer }) {
    const isMobile = useMedia('(max-width: 768px)', false);

    if (!footerGlobal.rows) return <></>;

    if (isMobile) {
        return <FooterLinksMobile footerGlobal={footerGlobal} />;
    }

    return (
        <div className={styles.container}>
            <nav aria-label="Footer navigation" className={styles.links}>
                {footerGlobal.rows.map((row) => (
                    <ul key={row.id} className={styles.rootList}>
                        <li className={styles.rootItem}>
                            <span className={styles.title}>{row.name}</span>

                            {row.items && (
                                <ul className={styles.list}>
                                    {row.items.map((item) => (
                                        <li key={item.id}>
                                            <Link
                                                title={title(item.link)}
                                                href={href(item.link)}
                                                className={styles.link}
                                            >
                                                {item.link.label}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    </ul>
                ))}
            </nav>
        </div>
    );
}
